import { render, staticRenderFns } from "./admin-after-demo-booking-surveys.vue?vue&type=template&id=afd718ac&scoped=true&"
import script from "./admin-after-demo-booking-surveys.vue?vue&type=script&lang=js&"
export * from "./admin-after-demo-booking-surveys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd718ac",
  null
  
)

export default component.exports